<template>
    <div>
        <Header />
        <PageTitle />
        <ResetPassword />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../RecoverPassword/PageTitle'
import ResetPassword from '../RecoverPassword/ResetPassword'
import Footer from '../Layout/Footer'

export default {
    name: 'RecoverPasswordPage',
    components: {
        Header,
        PageTitle,
        ResetPassword,
        Footer,
    }
}
</script>